<template>
    <div>
        <div class="d-flex flex-column-fluid">
            <!--begin::Container-->
            <div class="container-fluid">
                <div class="row">
                    <div class="col-12">
                        <div class="row">
                            <div class="col-lg-12 col-xl-12">
                                <div
                                    class=" card card-custom gutter-b bg-transparent shadow-none border-0">
                                    <div
                                        class=" card-header align-items-center border-bottom-dark px-0">
                                        <div class="card-title mb-0">
                                            <h3 v-if="sale.order_id" class="card-label mb-0 font-weight-bold text-body">Заказ №{{sale.order_id}}</h3>
                                            <h3 v-else class="card-label mb-0 font-weight-bold text-body">Новый заказ </h3>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-12 col-xl-12">
                                <div class="card card-custom gutter-b bg-white border-0">
                                    <div class="card-body">
                                        <form>
                                            <div class="form-group row">
                                                <div class="col-md-6">
                                                    <label class="text-body">Использовать данные с запроса</label>
                                                    <fieldset class="form-group mb-3">
                                                        <select
                                                            @change="getQuotation()" v-model="selectedQuotation" class="js-states form-control bg-transparent">
                                                            <option value="">Выбрать запрос</option>
                                                            <option v-for="quotation in quotations" v-bind:value="quotation.id">{{ quotation.id }}</option>
                                                        </select>
                                                    </fieldset>
                                                    <label class="text-body">Клиент</label>
                                                    <fieldset class="form-group mb-3">
                                                        <multiselect
                                                            v-model="sale.customer"
                                                            :options="customers"
                                                            :custom-label="customerNameSurname"
                                                            placeholder="Выбрать клиента"
                                                            label="name"
                                                            track-by="customer_id"
                                                            :multiple="false"
                                                            :taggable="true"
                                                            :internal-search="false"
                                                            :loading="customersLoading"
                                                            @search-change="searchCustomers"
                                                            @select="getSelectedCustomerData"
                                                        >
                                                        </multiselect>
                                                        <small class="form-text text-danger" v-if="errors.has('customer')" v-text="errors.get('customer')"></small>
                                                    </fieldset>

                                                    <div class="row">
                                                        <div class="col-md-12">
                                                            <label class="text-body">Адрес</label>
                                                            <fieldset class="form-group mb-3">
                                                                <input type="text" class="form-control bg-white" value="" v-model="sale.billing_street_address"/>
                                                                <small class="form-text text-danger" v-if="errors.has('billing_street_address')" v-text="errors.get('billing_street_address')" ></small>
                                                            </fieldset>
                                                        </div>

                                                        <div class="col-6">
                                                            <label class="text-body">ZIP</label>
                                                            <fieldset class="form-group mb-3">
                                                                <input type="text" class="form-control bg-white" value="" v-model="sale.billing_postcode"/>
                                                                <small class="form-text text-danger" v-if="errors.has('billing_postcode')" v-text="errors.get('billing_postcode')" ></small>
                                                            </fieldset>
                                                        </div>
                                                        <div class="col-6">
                                                            <label class="text-body">Город</label>
                                                            <fieldset class="form-group mb-3">
                                                                <input type="text" class="form-control bg-white" value="" v-model="sale.billing_city"/>
                                                                <small class="form-text text-danger" v-if="errors.has('billing_city')" v-text="errors.get('billing_city')" ></small>
                                                            </fieldset>
                                                        </div>
                                                        <div class="col-12">
                                                        <label class="text-body">Страна</label>

                                                        <fieldset class="form-group mb-3">
                                                            <multiselect
                                                                @input="computeValues('updateCountry')"
                                                                v-model="sale.billing_country"
                                                                :options="countries"
                                                                :custom-label="countryName"
                                                                placeholder="Выбрать страну"
                                                                label="name"
                                                                track-by="country_id"
                                                                :multiple="false"
                                                                :taggable="true"
                                                            >
                                                            </multiselect>
                                                            <small class="form-text text-danger" v-if="errors.has('billing_country')" v-text="errors.get('billing_country')" ></small>
                                                        </fieldset>
                                                        </div>
                                                        <div class="col-6">
                                                        <label class="text-body">Эл. Почта</label>
                                                        <fieldset class="form-group mb-3">
                                                            <input type="text" class="form-control bg-white" value="" v-model="sale.billing_email"/>
                                                            <small class="form-text text-danger" v-if="errors.has('billing_email')" v-text="errors.get('billing_email')" ></small>
                                                        </fieldset>
                                                        </div>
                                                        <div class="col-6">
                                                        <label class="text-body">Телефон</label>
                                                        <fieldset class="form-group mb-3">
                                                            <input type="text" class="form-control bg-white" value="" v-model="sale.billing_phone"/>
                                                            <small class="form-text text-danger" v-if="errors.has('billing_phone')" v-text="errors.get('billing_phone')" ></small>
                                                        </fieldset>
                                                        </div>
                                                        <div class="col-12 mb-3">
                                                            <span class="text-dark">Юр. лицо</span>
                                                            <div class="custom-control switch custom-switch-info custom-switch custom-control-inline mr-0">
                                                                <input
                                                                    @change="computeValues('legalPerson')"
                                                                    type="checkbox"
                                                                    class="custom-control-input"
                                                                    v-model="sale.billing_is_legal_person"
                                                                    :id="`customSwitchStatus${sale.billing_is_legal_person}`"
                                                                    :checked="sale.billing_is_legal_person === 1"
                                                                />
                                                                <label class="custom-control-label mr-1" :for="`customSwitchStatus${sale.billing_is_legal_person}`"></label>
                                                            </div>
                                                        </div>
                                                        <div class="col-6" v-if="sale.billing_is_legal_person">
                                                            <label class="text-body">Нр. Регистрации</label>
                                                            <fieldset class="form-group mb-3">
                                                                <input type="text" class="form-control bg-white" value="" v-model="sale.billing_registration_number"/>
                                                                <small class="form-text text-danger" v-if="errors.has('billing_registration_number')" v-text="errors.get('billing_registration_number')" ></small>
                                                            </fieldset>
                                                        </div>
                                                        <div class="col-6" v-if="sale.billing_is_legal_person">
                                                            <label class="text-body">Налоговый номер</label>
                                                            <fieldset class="form-group mb-3">
                                                                <input @input="computeValues('updateCountry')" type="text" class="form-control bg-white" value="" v-model="sale.billing_tax_number"/>
                                                                <small class="form-text text-danger" v-if="errors.has('billing_tax_number')" v-text="errors.get('billing_tax_number')" ></small>
                                                            </fieldset>
                                                        </div>
                                                        <div class="col-6" v-if="sale.billing_is_legal_person">
                                                            <label class="text-body">Юр. адрес</label>
                                                            <fieldset class="form-group mb-3">
                                                                <input type="text" class="form-control bg-white" value="" v-model="sale.billing_company_address"/>
                                                                <small class="form-text text-danger" v-if="errors.has('billing_company_address')" v-text="errors.get('billing_company_address')" ></small>
                                                            </fieldset>
                                                        </div>

                                                        <div class="col-6">
                                                        <label class="text-body">Компания</label>
                                                        <fieldset class="form-group mb-3">
                                                            <select
                                                                v-model="sale.company_id" class="js-states form-control bg-transparent">
                                                                <option value=""></option>
                                                                <option v-for="company in companies" v-bind:value="company.id">{{ company.name }}</option>
                                                            </select>
                                                        </fieldset>
                                                        </div>

                                                        <div class="col-6" v-if="companyBankAccounts.length > 1">
                                                        <label class="text-body">Банковский счёт</label>
                                                        <fieldset class="form-group mb-3">
                                                            <select
                                                                v-model="sale.company_bank_account_id" class="js-states form-control bg-transparent">
                                                                <option v-for="account in companyBankAccounts" v-bind:value="account.id">{{ account.label }}</option>
                                                            </select>
                                                        </fieldset>
                                                        </div>

                                                        <div class="col-6">
                                                        <label class="text-body">Экспортер</label>
                                                        <fieldset class="form-group mb-3">
                                                            <select
                                                                v-model="sale.exporter_id" class="js-states form-control bg-transparent">
                                                                <option value=""></option>
                                                                <option v-for="company in companies" v-bind:value="company.id">{{ company.name }}</option>
                                                            </select>
                                                        </fieldset>
                                                        </div>

                                                    </div>


                                                </div>

                                                <!-- Two to a row, so the invoice block fits under them. -->
                                                <div class="col-md-6">
                                                    <div class="row">
                                                        <div class="col-6">
                                                            <label class="text-body">Склад</label>
                                                            <fieldset class="form-group mb-3">
                                                                <select
                                                                    v-model="sale.warehouse_id"
                                                                    class="js-states form-control bg-transparent"
                                                                    @change="taxApply()"
                                                                >
                                                                    <option value="">Выбрать склад</option>
                                                                    <option v-for="warehouse in warehouses" v-bind:value="warehouse.warehouse_id">
                                                                        {{ warehouse.warehouse_name }}
                                                                    </option>
                                                                </select>
                                                                <small class="form-text text-danger" v-if="errors.has('warehouse_id')" v-text="errors.get('warehouse_id')" ></small>
                                                            </fieldset>
                                                        </div>
                                                        <div class="col-6">
                                                            <label class="text-body">Дата продажи</label>
                                                            <fieldset class="form-group mb-3">
                                                                <input type="date" class="form-control bg-white" value="" v-model="sale.sale_date"/>
                                                                <small class="form-text text-danger" v-if="errors.has('sale_date')" v-text="errors.get('sale_date')" ></small>
                                                            </fieldset>
                                                        </div>

                                                        <div class="col-6">
                                                            <label class="text-body">Метод доставки</label>
                                                            <fieldset class="form-group mb-3">
                                                                <select v-model="sale.shipping_method_id" class="js-states form-control bg-transparent" @change="fetchShippingOptions()">
                                                                    <option value="">Выбрать метод доставки</option>
                                                                    <option
                                                                        v-for="shipping_method in shipping_methods"
                                                                        v-bind:value="shipping_method.shipping_method_id"
                                                                    >
                                                                        {{ (localised(shipping_method.shipping_method_description) || {}).name }}
                                                                    </option>
                                                                </select>
                                                                <small class="form-text text-danger" v-if="errors.has('shipping_method_id')" v-text="errors.get('shipping_method_id')"></small>
                                                            </fieldset>

                                                            <fieldset v-if="sale.shipping_method_id == 2" class="form-group mb-3">
                                                                <select v-model="sale.shipping_option_id" class="js-states form-control bg-transparent">
                                                                    <option value="">Выбрать пакомат</option>
                                                                    <option
                                                                        v-for="shipping_option in shipping_options"
                                                                        v-bind:value="shipping_option.shipping_option_id"
                                                                    >
                                                                        {{ shipping_option.shipping_option_link }}
                                                                    </option>
                                                                </select>
                                                                <small class="form-text text-danger" v-if="sale.shipping_method_id == 2 && errors.has('shipping_option_id')" v-text="errors.get('shipping_option_id')"></small>
                                                            </fieldset>
                                                        </div>
                                                        <div class="col-6">
                                                            <label class="text-body">Стоимость доставки</label>
                                                            <fieldset class="form-group mb-3">
                                                                <input type="text" class="form-control bg-white" value="" v-model="sale.shipping_cost"/>
                                                                <small class="form-text text-danger" v-if="errors.has('shipping_cost')" v-text="errors.get('shipping_cost')" ></small>
                                                            </fieldset>
                                                        </div>

                                                        <div class="col-6" v-if="sale.order_id">
                                                            <label class="text-body">Статус заказа</label>
                                                            <fieldset class="form-group mb-3">
                                                                <select v-model="sale.order_status_id" class="js-states form-control bg-transparent">
                                                                    <option
                                                                        v-for="order_status in order_statuses"
                                                                        v-bind:value="order_status.order_status_id"
                                                                    >
                                                                        {{ (localised(order_status.detail) || {}).name }}
                                                                    </option>
                                                                </select>
                                                                <small class="form-text text-danger" v-if="errors.has('order_status_id')" v-text="errors.get('order_status_id')"></small>
                                                            </fieldset>
                                                        </div>
                                                        <div class="col-6">
                                                            <label class="text-body">Метод оплаты</label>
                                                            <fieldset class="form-group mb-3">
                                                                <select
                                                                    v-model="sale.payment_method_id"
                                                                    class="js-states form-control bg-transparent"
                                                                >
                                                                    <option value="">Выбрать метод оплаты</option>
                                                                    <option
                                                                        v-if="payment_method.payment_method_status == 1 "
                                                                        v-for="payment_method in payment_methods"
                                                                        v-bind:value="payment_method.payment_method_id"
                                                                    >
                                                                        <span v-if="payment_method.payment_method_name == 'cod'">Uz vietas</span>
                                                                        <span v-if="payment_method.payment_method_name == 'banktransfer'" >Bankas parskaitījums</span>
                                                                        <span v-if="payment_method.payment_method_name == 'online'">Ar karti</span>
                                                                    </option>
                                                                </select>
                                                                <small class="form-text text-danger" v-if="errors.has('payment_method_id')" v-text="errors.get('payment_method_id')" ></small>
                                                            </fieldset>
                                                        </div>

                                                        <div class="col-6">
                                                            <label class="text-body">Номер документа</label>
                                                            <fieldset class="form-group mb-3">
                                                                <input type="text" class="form-control bg-white" value="" v-model="sale.code"/>
                                                                <small class="form-text text-danger" v-if="errors.has('code')" v-text="errors.get('code')" ></small>
                                                            </fieldset>
                                                        </div>
                                                        <div class="col-6">
                                                            <label class="text-body">Оплатить до</label>
                                                            <fieldset class="form-group mb-3">
                                                                <input type="date" class="form-control bg-white" v-model="sale.payment_due_date"/>
                                                                <small class="form-text text-danger" v-if="errors.has('payment_due_date')" v-text="errors.get('payment_due_date')" ></small>
                                                            </fieldset>
                                                        </div>
                                                    </div>

                                                    <!-- Printed in the transport block of the invoice, proforma and
                                                         packing list. The carrier differs per order, so typed here. -->
                                                    <div class="border-top pt-3 mt-1">
                                                        <h6 class="text-dark mb-3">Данные для счёта</h6>
                                                        <div class="row">
                                                            <div class="col-6">
                                                                <label class="text-body">Описание (Description)</label>
                                                                <fieldset class="form-group mb-3">
                                                                    <input type="text" class="form-control bg-white" v-model="sale.invoice_description"/>
                                                                </fieldset>
                                                            </div>
                                                            <div class="col-6">
                                                                <label class="text-body">Транспорт (Transport)</label>
                                                                <fieldset class="form-group mb-3">
                                                                    <input type="text" class="form-control bg-white" v-model="sale.invoice_transport"/>
                                                                </fieldset>
                                                            </div>
                                                            <div class="col-6">
                                                                <label class="text-body">Перевозчик (Carrier)</label>
                                                                <fieldset class="form-group mb-3">
                                                                    <input type="text" class="form-control bg-white" v-model="sale.invoice_sender"/>
                                                                </fieldset>
                                                            </div>
                                                            <div class="col-6">
                                                                <label class="text-body">Водитель (Driver)</label>
                                                                <fieldset class="form-group mb-3">
                                                                    <input type="text" class="form-control bg-white" v-model="sale.invoice_trucker"/>
                                                                </fieldset>
                                                            </div>
                                                            <div class="col-6">
                                                                <label class="text-body">НДС перевозчика (VAT No.)</label>
                                                                <fieldset class="form-group mb-3">
                                                                    <input type="text" class="form-control bg-white" v-model="sale.invoice_sender_vat"/>
                                                                </fieldset>
                                                            </div>
                                                            <div class="col-6">
                                                                <label class="text-body">Дата доставки (Delivery date)</label>
                                                                <fieldset class="form-group mb-3">
                                                                    <input type="date" class="form-control bg-white" v-model="sale.invoice_delivery_date"/>
                                                                    <small class="form-text text-danger" v-if="errors.has('invoice_delivery_date')" v-text="errors.get('invoice_delivery_date')" ></small>
                                                                </fieldset>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                            <Offer v-if="type=='offer'"></Offer>
                            <div v-else class="col-lg-12 col-xl-12">
                                <div class="card card-custom gutter-b bg-white border-0">
                                    <div class="card-body">
                                        <div class="col-md-12" style="padding-right: 0; padding-left: 0">
                                            <label class="text-body">Товары</label>
                                            <fieldset class="form-group mb-3 d-flex">
                                                <multiselect
                                                    v-model="productSearchSelection"
                                                    :options="productSearchResults"
                                                    :custom-label="productSearchLabel"
                                                    placeholder="Найти товар по названию, артикулу или коду"
                                                    track-by="key"
                                                    :internal-search="false"
                                                    :loading="productSearchLoading"
                                                    :options-limit="50"
                                                    selectLabel=""
                                                    selectedLabel=""
                                                    deselectLabel=""
                                                    @search-change="searchOrderFormProducts"
                                                    @select="addSearchResult"
                                                >
                                                    <span slot="noResult">Ничего не найдено</span>
                                                    <span slot="noOptions">Начните вводить название или артикул</span>
                                                </multiselect>
                                            </fieldset>
                                            <small class="form-text text-danger" v-if="errors.has('product_id')" v-text="errors.get('product_id')" ></small>
                                        </div>

                                        <div class="col-12" style="padding: 0" v-if="display_table">
                                            <div class="table-responsive">
                                                <table class="table table-striped text-body" id="orderTable">
                                                    <thead>
                                                        <tr>
                                                            <th class="border-0 header-heading" scope="col">ID</th>
                                                            <th class="border-0 header-heading" scope="col">Название</th>
                                                            <th class="border-0 header-heading" scope="col">Остаток</th>
                                                            <th class="border-0 header-heading" scope="col">Код</th>
                                                            <th class="border-0 header-heading" scope="col">Кол-во</th>
                                                            <th class="border-0 header-heading" scope="col">Цена стандарт за шт.</th>
                                                            <th class="border-0 header-heading" scope="col">Скидка</th>
                                                            <th class="border-0 header-heading" scope="col">Цена со скидкой и налогом</th>
                                                            <th class="border-0 header-heading" scope="col" style="min-width: 120px">Налог</th>
                                                            <th class="border-0 header-heading" scope="col">Сумма</th>
                                                            <th class="border-0 header-heading" scope="col"></th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                    <tr class="" v-for="(selectedProduct, index) in selectedProducts">
                                                        <td>{{ index + 1 }}</td>
                                                        <td>
                                                            {{ selectedProduct.title }}
                                                            <!-- A gift goes out at 0 and is booked as one (no income, no VAT),
                                                                 which a plain 0 price is not: that means "not set" and takes
                                                                 the catalogue price. -->
                                                            <label class="d-flex align-items-center mt-1 mb-0 text-nowrap" style="cursor: pointer">
                                                                <input type="checkbox" class="mr-1" :checked="!!selectedProduct.is_gift" @change="toggleGift(index, $event.target.checked)" />
                                                                <span :class="selectedProduct.is_gift ? 'label label-inline label-light-success font-weight-bold' : 'text-muted small'">Подарок</span>
                                                            </label>
                                                        </td>
                                                        <td>{{ (selectedProduct.available_qty)?selectedProduct.available_qty:0 }}</td>
                                                        <td>{{ (selectedProduct.product_sku)?selectedProduct.product_sku:'' }}</td>
                                                        <td class="text-center">
                                                            <input type="text" class="form-control" placeholder="Ввести количество" v-model="sale.qty[index]" @change="computeValues('qty')" />
                                                            <small class="form-text text-danger" v-if="errors.has('qty.' + index)" v-text="errors.get('qty.' + index)" ></small>
                                                        </td>
                                                        <td class="text-center">
                                                            <div class="input-group">
                                                                <input type="text" class="form-control" placeholder="Ввести цену" readonly :value="selectedProduct.product_price_with_vat" />
                                                                <div class="input-group-append">
                                                                    <span class="input-group-text" style="border: none;">€</span>
                                                                </div>
                                                                <small class="form-text text-danger" v-if="errors.has('price.' + index)" v-text="errors.get('price.' + index)" ></small>
                                                            </div>
                                                        </td>
                                                        <td class="text-center">
                                                            <div class="input-group">
                                                                <input type="text" class="form-control" v-model="sale.discount[index]" :disabled="!!selectedProduct.is_gift" @change="computeValues('discount')" />
                                                                <div class="input-group-append">
                                                                    <span class="input-group-text" style="border: none;">%</span>
                                                                </div>
                                                                <small class="form-text text-danger" v-if="errors.has('product_discount.' + index)" v-text="errors.get('product_discount.' + index)" ></small>
                                                            </div>
                                                        </td>
                                                        <td class="text-center">
                                                            <div class="input-group">
                                                                <input type="text" class="form-control" v-model="sale.discount_price_with_tax[index]" :disabled="!!selectedProduct.is_gift" @change="computeValues('price', index)" />
                                                                <div class="input-group-append">
                                                                    <span class="input-group-text" style="border: none;">€</span>
                                                                </div>
                                                                <small class="form-text text-danger" v-if="errors.has('product_discount_price_with_tax.' + index)" v-text="errors.get('product_discount_price_with_tax.' + index)" ></small>
                                                            </div>
                                                        </td>
                                                        <td class="text-center" style="min-width: 120px">
                                                            <div class="input-group">
                                                                <select class="form-control" v-model.number="selectedProduct.tax_rate" @change="computeValues('tax')">
                                                                    <option v-for="rate in taxOptionsFor(selectedProduct)" :key="'tax'+rate" :value="rate">
                                                                        {{ rate }}
                                                                    </option>
                                                                </select>
                                                                <div class="input-group-append">
                                                                    <span class="input-group-text" style="border: none;">%</span>
                                                                </div>
                                                                <small class="form-text text-danger" v-if="errors.has('tax_rate.' + index)" v-text="errors.get('tax_rate.' + index)" ></small>
                                                            </div>
                                                        </td>
                                                        <td class="text-center">
                                                            <div class="input-group">
                                                                <input type="text" readonly class="form-control" placeholder="Ввести цену"
                                                                       :value="sumProductPrice(index)"
                                                                />
                                                                <div class="input-group-append">
                                                                    <span class="input-group-text" style="border: none;">€</span>
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td class="text-center">
                                                            <button type="button" class="btn btn-sm btn-light text-danger"
                                                                    title="Убрать из заказа"
                                                                    @click="removeSelectedProduct(index)">&times;</button>
                                                        </td>

                                                        <input type="hidden" :set="(sale.product_id[index] = selectedProduct.product_id)" />
                                                        <input type="hidden" :set="(sale.product_name[index] = selectedProduct.title)" />
                                                        <input type="hidden" :set="(sale.price[index] = selectedProduct.product_price_with_vat)" />
                                                        <input type="hidden" :set="(sale.discount_price[index] = selectedProduct.product_discount_price)" />
                                                        <input type="hidden" :set="(sale.tax_rate[index] = (selectedProduct.tax_rate>0) ? selectedProduct.tax_rate/100 + 1 : 0)" />
                                                        <input type="hidden" :set="(sale.tax_line_amount[index] = (selectedProduct.tax_rate>0)
                                                            ? (selectedProduct.product_discount_price > 0)
                                                                ? (selectedProduct.product_discount_price * (selectedProduct.tax_rate/100 + 1) - selectedProduct.product_discount_price).toFixed(2)
                                                                : (selectedProduct.product_price * (selectedProduct.tax_rate/100 + 1) - selectedProduct.product_price).toFixed(2)
                                                            : 0)" />
                                                        <input type="hidden" :set="(sale.product_combination_id[index] = selectedProduct.product_combination_id)" />
                                                    </tr>
                                                    <tr>
                                                        <td></td>
                                                        <td>
                                                            <small class="form-text text-danger" v-if="errors.has('qty')" v-text="errors.get('qty')" ></small>
                                                        </td>
                                                        <td colspan="5">
                                                            <small class="form-text text-danger" v-if="errors.has('price')" v-text="errors.get('price')" ></small>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td></td>
                                                        <td colspan="3"><strong>Итого позиций</strong></td>
                                                        <td class="text-center"><strong>{{ productsCount }}</strong></td>
                                                        <td colspan="4"></td>
                                                        <td class="text-center"><strong>{{ goodsWithVat }} €</strong></td>
                                                        <td></td>
                                                    </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-12 col-xl-12">
                                <div class="card card-custom gutter-b bg-white border-0">
                                    <div class="card-body">
                                        <div class="row mb-3">
                                            <div class="col-6">
                                                <label>Внутренний комментарий:</label>
                                                <fieldset class="form-group mb-3">
                                                    <textarea
                                                          class="form-control"
                                                          id="label-textarea"
                                                          rows="6"
                                                          placeholder="Добавьте примечание"
                                                          style="height: 130px"
                                                          spellcheck="false"
                                                          v-model="sale.internal_note"
                                                      >{{ sale.internal_note }}
                                                    </textarea>
                                                </fieldset>
                                                <small class="form-text text-danger" v-if="errors.has('desc')" v-text="errors.get('desc')" ></small>
                                            </div>
                                            <div class="col-6">
                                                <label>Комментарий в счете:</label>
                                                <fieldset class="form-group mb-3">
                                                    <textarea
                                                          class="form-control"
                                                          id="label-textarea"
                                                          rows="6"
                                                          placeholder="Добавьте примечание"
                                                          style="height: 130px"
                                                          spellcheck="false"
                                                          v-model="sale.bill_note"
                                                      >{{ sale.bill_note }}
                                                    </textarea>
                                                </fieldset>
                                                <small class="form-text text-danger" v-if="errors.has('desc')" v-text="errors.get('desc')" ></small>
                                            </div>
                                            <div class="col-12 d-none">
                                                <label>Купон</label>
                                                <fieldset class="form-group mb-3">
                                                    <select class="form-control" v-model="selectedCoupon">
                                                        <option v-for="coupon in coupons" :selected="coupon.id == selectedCoupon" v-bind:value="coupon" >
                                                            {{ coupon.coupon_code }}
                                                        </option>
                                                    </select>
                                                    <small class="form-text text-danger" v-if="errors.has('coupon')" v-text="errors.get('coupon')" ></small>
                                                </fieldset>
                                            </div>
                                        </div>
                                        <Total :totals="offer_totals" v-if="type == 'offer'"></Total>
                                        <div v-else class="row justify-content-end">
                                            <div class="col-12 col-md-4">
                                                <div>
                                                    <table class="table right-table mb-0">
                                                        <tbody>
                                                        <tr class=" d-flex align-items-center justify-content-between" >
                                                            <th class="border-0">
                                                                <h5 class="font-size-h5 mb-0 font-size-bold text-dark">
                                                                    Товары без НДС:
                                                                </h5>
                                                            </th>
                                                            <td class="border-0 justify-content-end d-flex text-black-50 font-size-base" >
                                                                {{ sale.subtotal }} €
                                                            </td>
                                                        </tr>
                                                        <!-- Одна строка на ставку: заказ может смешивать 21% и 0%. -->
                                                        <tr class="d-flex align-items-center justify-content-between"
                                                            v-for="line in vatBreakdown" :key="'vat'+line.rate">
                                                            <th class="border-0">
                                                                <h5 class="font-size-h5 mb-0 font-size-bold text-dark">
                                                                    НДС {{ Number(line.rate).toFixed(0) }}%:
                                                                </h5>
                                                            </th>
                                                            <td class="border-0 justify-content-end d-flex text-black-50 font-size-base">
                                                                {{ Number(line.amount).toFixed(2) }} €
                                                            </td>
                                                        </tr>
                                                        <tr class="d-flex align-items-center justify-content-between" v-if="!vatBreakdown.length">
                                                            <th class="border-0">
                                                                <h5 class="font-size-h5 mb-0 font-size-bold text-dark" >Налог:</h5>
                                                            </th>
                                                            <td class="border-0 justify-content-end d-flex text-black-50 font-size-base" >
                                                                {{ (sale.tax_amount) }} €
                                                            </td>
                                                        </tr>
                                                        <tr class="d-flex align-items-center justify-content-between">
                                                            <th class="border-0">
                                                                <h5 class="font-size-h5 mb-0 font-size-bold text-dark" >Доставка без НДС:</h5>
                                                            </th>
                                                            <td class="border-0 justify-content-end d-flex text-black-50 font-size-base" >
                                                                {{ shippingWithoutVat }} €
                                                            </td>
                                                        </tr>
                                                        <tr class="d-flex align-items-center justify-content-between">
                                                            <th class="border-0">
                                                                <h5
                                                                    class="font-size-h5 mb-0 font-size-bold text-dark">Итого:</h5>
                                                            </th>
                                                            <td class="border-0 justify-content-end d-flex text-black-50 font-size-base">
                                                                {{ sale.payable }} €
                                                            </td>
                                                        </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-12 d-flex justify-content-end" style="padding-left: 0; padding-right: 0">
                                            <button class="btn btn-light" style="margin-right: 8px" :disabled="saving" @click="save('stay')">Сохранить</button>
                                            <button class="btn btn-light" style="margin-right: 8px" :disabled="saving" @click="save('list')">Сохранить и вернуться в список</button>
                                            <button class="btn btn-primary" :disabled="saving" @click="save('close')">Сохранить и закрыть</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ErrorHandling from "../../ErrorHandling";
import Multiselect from "vue-multiselect";
import Offer from "./Offer";
import Total from "./Total";

export default {
    components: {Multiselect, Offer, Total},
    data() {
        return {
            type: 'order',
            offer_totals: [],
            // Per-rate VAT, as computed by the server.
            // The search keeps its own selection. It used to share product_id
            // with the list of an order's products, so opening an order for
            // editing showed one of its products sitting in the search field.
            saving: false,
            savingTimer: null,
            // The id of the offer this form has already created, so a second
            // press updates it instead of making another one like it.
            offerId: null,
            productSearchSelection: null,
            productSearchResults: [],
            productSearchLoading: false,
            vatBreakdown: [],
            goodsWithVat: "0.00",
            shippingWithoutVat: "0.00",
            shippingTotalsTimer: null,
            display_form: 0,
            warehouse_state_id: 4491,
            sale: {
                code: null,
                customer: [],
                warehouse_id: "",
                desc: "",
                payable: 0,
                tax_id: "",
                tax_amount: 0,
                tax_line_amount: [],
                tax_rate: [],
                amount_paid: 0,
                due_amount: 0,
                sale_date: new Date().toISOString().substr(0, 10),
                product_id: [],
                product_name: [],
                qty: [],
                price: [],
                discount_price: [],
                discount: [],
                discount_price_with_tax: [],
                subtotal: 0,
                product_combination_id: [],
                billing_street_address: "",
                billing_city: "",
                billing_country: "",
                billing_postcode: "",
                billing_email: "",
                billing_phone: "",
                billing_is_legal_person: 0,
                billing_company_address: "",
                order_id: 0,
                shipping_cost: 0,
                order_status_id: 1,
                internal_note: '',
                bill_note: '',
                company_id: '',
                company_bank_account_id: '',
                exporter_id: '',
                payment_due_date: '',
                invoice_description: '',
                invoice_sender: '',
                invoice_sender_vat: '',
                invoice_transport: '',
                invoice_trucker: '',
                invoice_delivery_date: '',
            },
            currency: [],
            product_id: [],
            productsLoading: false,
            productSearchTimer: null,
            customersLoading: false,
            customerSearchTimer: null,
            combination_product_id: [],
            combination_products: [],
            customIndex: 0,
            display_table: false,
            searchParameter: "",
            sortBy: "id",
            sortType: "ASC",
            limit: 10,
            error_message: "",
            edit: false,
            actions: false,
            pagination: {},
            request_method: "",
            sales: [],
            warehouses: [],
            countries: [],
            companies: [],
            customers: [],
            products: [],
            payment_methods: [],
            shipping_methods: [],
            shipping_options: [],
            order_statuses: [],
            category_products: [],
            selectedProducts: [],
            token: [],
            taxes: [],
            quotations: [],
            selectedQuotation: "",
            selectedCustomerAddress: {},
            errors: new ErrorHandling(),
            tax_per_apply: 0,
            customer_address: [],
            coupons: [],
            selectedCoupon: {},
            selectedProductDropdown: {},
            csrf: document
                .querySelector('meta[name="csrf-token"]')
                .getAttribute("content"),
        };
    },
    methods: {
        /**
         * Dictionary entries come as one row per language. Taking [0] handed back
         * whichever the query returned first - English here, while the default is
         * Latvian, so shipping methods read "localpickup" in the admin.
         */
        localised(entries) {
            if (!Array.isArray(entries) || !entries.length) {
                return null;
            }

            const languageId = (window.appConfig && window.appConfig.defaultLanguageId) || null;
            const match = languageId
                ? entries.find(e => Number(e.language_id) === Number(languageId))
                : null;

            return match || entries[0];
        },
        fetchSaleQuotations() {
            this.$parent.loading = true;
            var token = localStorage.getItem("token");
            const config = {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            };
            var responseData = {};

            axios
                .get("/api/admin/sale_quotation", config)
                .then((res) => {
                    if (res.data.status == "Success") {
                        this.quotations = res.data.data;
                    }
                })
                .finally(() => (this.$parent.loading = false));
        },
        fetchCurrency() {
            this.$parent.loading = true;
            var token = localStorage.getItem("token");
            const config = {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            };
            var responseData = {};

            axios
                .get("/api/admin/currency?is_default=1", config)
                .then((res) => {
                    if (res.data.status == "Success") {
                        this.currency = res.data.data;
                    }
                })
                .finally(() => (this.$parent.loading = false));
        },
        sumProductPrice(index){
            if (this.isGiftLine(index)) {
                return '0.00';
            }
            if(this.sale.price[index] && this.sale.discount_price_with_tax[index] && this.sale.qty[index] ){
                let sum = 1;
                if(this.sale.discount_price_with_tax[index] > 0) {
                    sum = this.sale.discount_price_with_tax[index] * this.sale.qty[index];
                } else {
                    sum = this.sale[this.sale.discount_price[index] > 0 ? 'discount_price' : 'price'][index] * this.sale.qty[index];
                    if(this.sale.tax_rate[index] > 0){
                        sum *= this.sale.tax_rate[index];
                    }
                }

                return parseFloat(sum).toFixed(2);
            }
            return 0;
        },
        fetchCountries() {
            this.$parent.loading = true;
            var token = localStorage.getItem("token");
            const config = {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            };
            var responseData = {};

            return axios
                .get("/api/admin/country?getAllData=1", config)
                .then((res) => {
                    if (res.data.status == "Success") {
                        this.countries = res.data.data;
                    }
                })
                .finally(() => (this.$parent.loading = false));
        },
        fetchCompanies() {
            this.$parent.loading = true;
            var token = localStorage.getItem("token");
            const config = {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            };
            var responseData = {};

            axios
                .get("/api/admin/companies", config)
                .then((res) => {
                    if (res.data.data) {
                        this.companies = res.data.data;
                        this.syncBankAccountChoice();
                    }
                })
                .finally(() => (this.$parent.loading = false));
        },
        /**
         * Keeps the account selector on an account that belongs to the chosen
         * company, defaulting to that company's main one. Called both when the
         * company changes and once the company list arrives, since the order
         * may well be loaded before it.
         */
        syncBankAccountChoice() {
            const accounts = this.companyBankAccounts;

            if (!accounts.length) {
                return;
            }

            const stillValid = accounts.some(account => account.id === this.sale.company_bank_account_id);

            if (!stillValid) {
                const fallback = accounts.find(account => account.is_default) || accounts[0];
                this.sale.company_bank_account_id = fallback ? fallback.id : '';
            }
        },
        fetchWarehouses() {
            this.$parent.loading = true;
            var token = localStorage.getItem("token");
            const config = {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            };
            var responseData = {};

            axios
                .get("/api/admin/warehouse?getAllData=1", config)
                .then((res) => {
                    if (res.data.status == "Success") {
                        this.warehouses = res.data.data;
                        this.sale.warehouse_id = res.data.data[0]?.warehouse_id;
                    }
                })
                .finally(() => (this.$parent.loading = false));
        },
        fetchTaxes() {
            var token = localStorage.getItem("token");
            const config = {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            };
            var responseData = {};

            axios.get("/api/admin/tax", config).then((res) => {
                if (res.data.status == "Success") {
                    this.taxes = res.data.data;
                }
            });
        },
        fetchProducts(query) {
            this.$parent.loading = true;
            var token = localStorage.getItem("token");
            const config = {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            };
            // Only what the dropdown can show at once. Picking an item still
            // loads the full product on its own, so nothing else needs the
            // whole catalogue here.
            const search = encodeURIComponent(query || "");

            return axios
                .get(
                    `/api/admin/product/short-data?sortBy=id&sortType=asc&limit=50&searchParameter=${search}`,
                    config
                )
                .then((res) => {
                    if (res.data.status == "Success") {
                        this.products = res.data.data.data || res.data.data;

                        this.showSideBarProduct();
                    }
                })
                .finally(() => {
                    this.productsLoading = false;
                    this.$parent.loading = false;
                });
        },
        /**
         * Search products and their variations in one list.
         *
         * A variation used to be picked in a second field that appeared under
         * the first, so ordering one size of one colour took two steps and the
         * form kept offering the rest of the variations afterwards. Each
         * variation is a row of its own here, with its own code and stock.
         */
        searchOrderFormProducts(query) {
            this.productSearchLoading = true;

            clearTimeout(this.productSearchTimer);

            this.productSearchTimer = setTimeout(() => {
                const search = encodeURIComponent(query || "");
                const warehouse = this.sale.warehouse_id
                    ? `&warehouse_id=${this.sale.warehouse_id}`
                    : "";

                axios
                    .get(`/api/admin/order-form/products?q=${search}${warehouse}`, this.token)
                    .then((res) => {
                        this.productSearchResults = (res.data && res.data.data) || [];
                    })
                    .catch(() => (this.productSearchResults = []))
                    .finally(() => (this.productSearchLoading = false));
            }, 300);
        },
        productSearchLabel(option) {
            let name = option.title;

            if (option.sku) {
                name += " - " + option.sku;
            }

            return name + " (" + option.available_qty + ")";
        },
        /**
         * Put the chosen row into the order.
         *
         * The price still comes from the product itself, which is where a
         * customer's own price is worked out - the search only says which line
         * was meant.
         */
        async addSearchResult(option) {
            await this.addProduct({ product_id: option.product_id, qty: 1 }, option.product_id);

            if (!option.product_combination_id) {
                // A variation is added through addCombinationProduct, which works
                // the row out for itself. A plain product has nobody to do that,
                // so its price cell stayed empty and the line counted as zero.
                setTimeout(() => this.computeValues('addProduct'), 300);
                return;
            }

            const variation = this.combination_products.find(
                item => item.product_combination_id === option.product_combination_id
            );

            if (!variation) {
                this.$toaster.error("Вариация не найдена");
                return;
            }

            this.addCombinationProduct(variation);
            this.combination_products = [];
        },
        searchProducts(query) {
            this.productsLoading = true;

            if (this.productSearchTimer) {
                clearTimeout(this.productSearchTimer);
            }

            // Wait for a pause in typing so every keystroke is not a request.
            this.productSearchTimer = setTimeout(() => {
                this.fetchProducts(query);
            }, 300);
        },
        fetchCustomers(query) {
            this.$parent.loading = true;
            var token = localStorage.getItem("token");
            const config = {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            };

            // A page at a time instead of all three thousand: the order brings
            // its own customer along, so the list is only for picking another.
            const search = encodeURIComponent(query || "");

            return axios
                .get(`/api/admin/customer?limit=50&searchParameter=${search}`, config)
                .then((res) => {
                    if (res.data.status == "Success") {
                        this.customers = res.data.data.data || res.data.data;
                    }
                })
                .finally(() => {
                    this.customersLoading = false;
                    this.$parent.loading = false;
                });
        },
        searchCustomers(query) {
            this.customersLoading = true;

            if (this.customerSearchTimer) {
                clearTimeout(this.customerSearchTimer);
            }

            this.customerSearchTimer = setTimeout(() => {
                this.fetchCustomers(query);
            }, 300);
        },
        fetchPaymentMethods() {
            this.$parent.loading = true;
            var token = localStorage.getItem("token");
            const config = {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            };
            var responseData = {};

            axios
                .get("/api/admin/payment_method?getAllData=1", config)
                .then((res) => {
                    if (res.data.status == "Success") {
                        this.payment_methods = res.data.data;
                    }
                })
                .finally(() => (this.$parent.loading = false));
        },
        fetchShippingMethods() {
            this.$parent.loading = true;
            var token = localStorage.getItem("token");
            const config = {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            };
            var responseData = {};

            axios
                .get("/api/admin/shipping_method?getDetail=1", config)
                .then((res) => {
                    if (res.data.status == "Success") {
                        this.shipping_methods = res.data.data;
                    }
                })
                .finally(() => (this.$parent.loading = false));
        },
        fetchShippingOptions() {
            this.current_shipping_method = this.shipping_methods.filter(method => method.shipping_method_id == this.sale.shipping_method_id);
            if(this.current_shipping_method[0].shipping_method_has_options) {
                this.$parent.loading = true;
                var token = localStorage.getItem("token");
                const config = {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                };
                var responseData = {};

                axios
                    .get("/api/admin/shipping_method/"+this.sale.shipping_method_id+"/options", config)
                    .then((res) => {
                        if (res.data.status == "Success") {
                            this.shipping_options = res.data.data;
                        }
                    })
                    .finally(() => (this.$parent.loading = false));
            }

        },
        fetchOrderStatuses() {
            this.$parent.loading = true;
            var token = localStorage.getItem("token");
            const config = {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            };
            var responseData = {};

            axios
                .get("/api/admin/order-status", config)
                .then((res) => {
                    if (res.data.status == "Success") {
                        this.order_statuses = res.data.data;
                    }
                })
                .finally(() => (this.$parent.loading = false));
        },
        getSelectedCustomerData(selectedOption, id) {
            this.sale.billing_is_legal_person = selectedOption.customer_is_legal_person;
            this.sale.billing_tax_number = selectedOption.customer_tax_number;
            this.sale.billing_registration_number = selectedOption.customer_registration_number;
            this.sale.billing_email = selectedOption.customer_email;
            this.sale.billing_street_address = selectedOption.customer_address[0].street_address;
            this.sale.billing_city = selectedOption.customer_address[0].city;
            this.sale.billing_postcode = selectedOption.customer_address[0].postcode;
            this.sale.billing_country = selectedOption.customer_address[0].country_id;
            this.sale.billing_phone = selectedOption.customer_address[0].phone;
            this.sale.billing_company_address = selectedOption.company_address;
        },
        addsale() {
            this.$parent.loading = true;
            var url = "/api/admin/sale";
            if (this.edit === false) {
                // Add
                this.request_method = "post";
            } else {
                // Update
                var url = "/api/admin/sale/" + this.sale.id;
                this.request_method = "put";
            }
            this.sale.shipping_cost = parseFloat(this.sale.shipping_cost.toString().replace(',','.'))
            axios[this.request_method](url, this.sale, this.token)
                .then((res) => {
                    if (res.data.status == "Success") {
                        this.display_form = 0;
                        this.sale = {
                            saler_id: "",
                            sale_date: new Date().toISOString().substr(0, 10),
                            desc: "",
                            payable: 0,
                            amount_paid: 0,
                            discount: 0,
                            due_amount: 0,
                            product_id: [],
                            product_name: [],
                            product_combination_id: [],
                            price: [],
                            discount_price_with_tax: [],
                            qty: [],
                            warehouse_id: "",
                            subtotal: 0,
                            shipping_method_id,
                        };
                        this.errors = new ErrorHandling();
                        this.selectedProducts = [];
                        this.$toaster.success(res.data.message);
                    } else {
                        this.$toaster.error(res.data.message);
                    }
                })
                .catch((error) => {
                    this.error_message = "";
                    this.errors = new ErrorHandling();
                    if (error.response.status == 422) {
                        if (error.response.data.status == "Error") {
                            this.$toaster.error(error.response.data.message);
                        } else {
                            this.errors.record(error.response.data.errors);
                        }
                    } else if (error.response.status == 500) {
                        this.$toaster.error(error.response.data.message);
                    }
                })
                .finally(() => (this.$parent.loading = false));
        },
        /**
         * Resolve the effective unit price of every row, then let the server add
         * it all up.
         *
         * The arithmetic used to live here, with the VAT divisor written in as
         * 1.21 - so a product on any other rate, and a zero rate exists, came out
         * wrong, and the totals on screen could disagree with what was saved.
         */
        computeValues: function (method, index = null) {
            if (this.sale.qty.length != this.sale.price.length) {
                this.sale.subtotal = 0;
                this.sale.payable = 0;
                this.sale.tax_amount = 0;
                return;
            }

            for (var i = 0; i < this.sale.qty.length; i++) {
                if (this.isGiftLine(i)) {
                    this.sale.discount[i] = '';
                    this.sale.discount_price_with_tax[i] = 0;
                    continue;
                }

                if (method == 'price' && index == i) {
                    this.sale.discount[i] = 0;
                }

                if (this.sale.discount[i] > 0) {
                    // Discount entered as a percentage of the catalogue price.
                    this.sale.discount_price_with_tax[i] = Number(
                        this.selectedProducts[i].product_price_with_vat -
                        (this.selectedProducts[i].product_price_with_vat * (this.sale.discount[i] / 100))
                    ).toFixed(2);
                } else if (this.sale.discount_price[i] > 0 && this.sale.discount_price[i] < this.sale.price[i]) {
                    // A discounted price entered directly; show what percentage it is.
                    this.sale.discount_price_with_tax[i] = this.sale.discount_price[i];
                    this.sale.discount[i] = Number(
                        ((this.sale.price[i] - this.sale.discount_price[i]) / this.sale.price[i]) * 100
                    ).toFixed(4);
                } else if (!this.sale.discount_price_with_tax[i]) {
                    this.sale.discount_price_with_tax[i] = this.sale.price[i];
                }

                if (this.sale.discount[i] == 0) {
                    this.sale.discount[i] = '';
                }
            }

            this.refreshTotals();
        },
        isGiftLine(index) {
            return !!(this.selectedProducts[index] && this.selectedProducts[index].is_gift);
        },
        toggleGift(index, on) {
            const line = this.selectedProducts[index];
            this.$set(line, 'is_gift', on);

            if (!on) {
                // Back to a paid line at the catalogue price.
                this.$set(line, 'gift_promotion_id', null);
                this.$set(this.sale.discount_price_with_tax, index, '');
            }

            this.computeValues('gift');
        },
        /**
         * The rates offered on a line.
         *
         * A line can carry a rate the list no longer has - an older order, a
         * rate since retired - and leaving it out would show that line at
         * whichever rate happens to come first, while the order keeps the one
         * it was saved with.
         */
        taxOptionsFor(selectedProduct) {
            const rates = this.taxes.map(tax => Number(tax.tax_rate)).filter(Number.isFinite);
            const own = Number(selectedProduct && selectedProduct.tax_rate);

            if (Number.isFinite(own) && !rates.includes(own)) {
                rates.push(own);
            }

            return rates.sort((a, b) => b - a);
        },
        /**
         * Ask the server for the totals of the rows as they stand.
         */
        refreshTotals() {
            const rows = this.sale.qty.map((qty, i) => ({
                qty: Number(qty) || 0,
                price_with_vat: this.isGiftLine(i) ? 0 : (Number(this.sale.discount_price_with_tax[i] || this.sale.price[i]) || 0),
                tax_rate: Number(
                    (this.selectedProducts[i] && this.selectedProducts[i].tax_rate) || 0
                ),
            }));

            // Supplies to a VAT registered business outside Latvia are zero rated.
            const vatExempt = Boolean(
                this.sale.billing_country &&
                this.sale.billing_country.country_name != 'Latvia' &&
                this.sale.billing_tax_number &&
                this.sale.billing_is_legal_person != 0
            );

            axios.post('/api/admin/order-form/totals', {
                rows: rows,
                shipping_cost: Number(this.sale.shipping_cost) || 0,
                vat_exempt: vatExempt,
            }, this.token)
                .then(res => {
                    const t = (res.data && res.data.data) || null;
                    if (!t) return;
                    this.sale.subtotal = Number(t.goods_without_vat).toFixed(2);
                    this.shippingWithoutVat = Number(t.shipping_without_vat).toFixed(2);
                    this.sale.payable = Number(t.total).toFixed(2);
                    this.sale.tax_amount = Number(t.tax_amount).toFixed(2);
                    this.goodsWithVat = Number(t.goods_with_vat).toFixed(2);
                    this.vatBreakdown = t.vat_breakdown || [];
                })
                .catch(() => {});
        },
        getCurrencyTitle() {
            return this.currency == null ? "" : "(" + this.currency.title + ")";
        },
        getQuotation() {
            if (this.selectedQuotation == "") {
                this.clearForm();
                return;
            }
            this.$parent.loading = true;
            var token = localStorage.getItem("token");
            const config = {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            };
            var responseData = {};

            axios
                .get(
                    "/api/admin/sale_quotation/" +
                    this.selectedQuotation +
                    "?getWarehouse=1&getTax=1&getDetail=1&productDetail=1&getCustomer=1&getProduct=1&getProductCombination=1",
                    config
                )
                .then((res) => {
                    if (res.data.status == "Success") {

                        this.clearFormGetQoutation();
                        this.fetchCurrency();
                        this.fetchWarehouses();
                        this.fetchCustomers();
                        this.fetchProducts();
                        this.fetchTaxes();
                        this.fetchCoupons();

                        this.sale.warehouse_id = res.data.data.warehouse.warehouse_id;
                        this.sale.customer = res.data.data.customer;
                        this.sale.desc = res.data.data.desc;

                        this.getSelectedCustomerData();
                        this.taxApply();
                        this.fetchCouponsByID(res.data.data.coupon_setting_id);

                        for (var k = 0; k < res.data.data.detail.length; k++) {
                            var detail = res.data.data.detail[k];

                            var valObj = this.product_id.filter(function (elem) {

                                if (elem.product_id == detail.product_id.product_id) {
                                    //console.log(elem.product_id + "==" + detail.product_id.product_id);
                                    return elem.product_id;
                                }
                            });

                            if (valObj.length > 0) {
                                //console.log(valObj[0].Value);
                            } else {
                                this.product_id.push({
                                    product_id: detail.product_id.product_id,
                                    detail: detail.product_id.detail,
                                });
                            }


                            //alert(detail.qty);


                            if (detail.product_id.product_type == "simple") {
                                this.addProduct(
                                    {
                                        product_id: detail.product_id.product_id,
                                        qty: detail.qty,
                                    },
                                    detail.product_id.product_id
                                );
                            }
                            if (detail.product_id.product_type == "variable") {
                                var combination_detail = detail.product_id.combination_detail;
                                var product = detail.product_id;

                                //console.log(combination_detail, "working");

                                if (combination_detail.length > 0) {
                                    var arr = {};
                                    for (var i = 0; i < combination_detail.length; i++) {

                                        arr.product_price = combination_detail[i].price;

                                        arr.product_combination_id =
                                            combination_detail[i].product_combination_id;
                                        var combination_name = "";
                                        if (combination_detail[i].combination.length > 0) {
                                            for (
                                                var j = 0;
                                                j < combination_detail[i].combination.length;
                                                j++
                                            ) {
                                                if (j == 0) {
                                                    combination_name =
                                                        (this.localised(combination_detail[i].combination[j].variation.detail) || {}).name;
                                                } else {
                                                    combination_name +=
                                                        "-" +
                                                        (this.localised(combination_detail[i].combination[j].variation.detail) || {}).name;
                                                }
                                                // console.log('i=' + i + 'j=' + j);
                                            }
                                        }

                                        arr.product_id = product.product_id;
                                        arr.product_type = product.product_type;
                                        arr.qty = detail.qty;
                                        arr.stock_status = "";
                                        arr.warehouse = "";
                                        arr.product_price = combination_detail[i].price;

                                        arr.title =
                                            product.detail.length > 0
                                                ? (this.localised(product.detail) || {}).title +
                                                " (" +
                                                combination_name +
                                                ")"
                                                : "";

                                        if (
                                            parseInt(detail.productCombinationId) ==
                                            parseInt(combination_detail[i].product_combination_id)
                                        ) {
                                            this.addCombinationProduct(
                                                arr,
                                                arr.product_combination_id
                                            );

                                            this.combination_product_id.push({
                                                qty: detail.qty,
                                                stock_status: "",
                                                warehouse: "",
                                                product_id: arr.product_id,
                                                product_combination_id: arr.product_combination_id,
                                                title: arr.title,
                                                product_type: "variable",
                                                product_price: arr.product_price,
                                            });
                                        }
                                        var valObj = this.combination_products.filter(function (elem) {

                                            if (elem.product_combination_id == arr.product_combination_id) {
                                                //console.log(elem.product_combination_id + "==" + arr.product_combination_id);
                                                return elem.product_combination_id;
                                            }
                                        });

                                        if (valObj.length > 0) {
                                            //console.log(valObj[0].Value);
                                        } else {
                                            this.combination_products.push(arr);
                                        }
                                        arr = {};

                                    }
                                }
                            }
                        }
                    }
                })
                .finally(() => (this.$parent.loading = false));
        },
        clearForm() {
            this.display_form = 0;
            this.display_table = false;
            //this.product_id = "";
            this.selectedQuotation = "";
            this.product_price = [];
            this.product_discount_price = [];
            this.combination_products = [];
            this.combination_product_id = [];
            this.selectedCoupon = {};

            this.sale = {
                desc: "",
                payable: 0,
                discount: 0,
                tax_id: "",
                tax_rate: 0,
                tax_amount: 0,
                amount_paid: 0,
                due_amount: 0,
                sale_date: new Date().toISOString().substr(0, 10),
                product_id: [],
                product_name: [],
                qty: [],
                price: [],
                discount_price: [],
                discount_price_with_tax: [],
                subtotal: 0,
                product_combination_id: [],
                order_status_id:1,
                payment_due_date: '',
                invoice_description: '',
                invoice_sender: '',
                invoice_sender_vat: '',
                invoice_transport: '',
                invoice_trucker: '',
                invoice_delivery_date: '',
            };

            this.errors = new ErrorHandling();
            this.selectedProducts = [];
            this.selectedCustomerAddress = {};
        },

        clearFormGetQoutation() {
            this.display_form = 0;
            this.display_table = false;
            //this.product_id = "";
            //this.selectedQuotation = "";
            this.product_price = [];
            this.product_discount_price = [];
            this.combination_products = [];
            this.combination_product_id = [];
            this.selectedCoupon = {};

            this.sale = {
                desc: "",
                payable: 0,
                discount: 0,
                tax_id: "",
                tax_amount: 0,
                amount_paid: 0,
                due_amount: 0,
                sale_date: new Date().toISOString().substr(0, 10),
                product_id: [],
                product_name: [],
                qty: [],
                price: [],
                discount_price: [],
                discount_price_with_tax: [],
                subtotal: 0,
                product_combination_id: [],
                order_status_id:1,
            };

            this.errors = new ErrorHandling();
            this.selectedProducts = [];
            this.selectedCustomerAddress = {};
        },

        taxApply() {
            //todo: use customer and product taxes
            this.tax_per_apply = 0;
            var page_url = "/api/admin/warehouse/" + this.sale.warehouse_id;
            axios.get(page_url, this.token).then((res) => {
                //console.log("current warehouse", res.data.data);
                this.warehouse_state_id = res.data.data['warehouse_state_id'];
                if (res.data.status == "Success") {
                    if (res.data.data.warehouse_tax != null) {
                        res.data.data.warehouse_tax.forEach((element) => {
                            this.tax_per_apply =
                                parseFloat(this.tax_per_apply) + parseFloat(element.tax_rate);
                        });
                    }
                }
            });
        },
        save(after = 'close'){
            // Two presses before the first answer used to mean two documents.
            if (this.saving) {
                return;
            }

            this.saving = true;
            clearTimeout(this.savingTimer);
            this.savingTimer = setTimeout(() => (this.saving = false), 20000);

            if(this.type == 'offer'){
                return this.saveOffer(after);
            }
            return this.saveTransaction(after)
        },
        /**
         * Save the offer and then do what the button asked.
         *
         * It used to ignore the button and never leave the page: whatever was
         * pressed, the form stayed where it was with no id of its own, so the
         * next press wrote another offer just like the last one. Three presses,
         * three offers.
         */
        saveOffer(after = 'close'){
            let products = this.$store.getters['offer/selectedProducts'];

            if (!this.sale.customer || !this.sale.customer.customer_id) {
                this.errors.record({ customer: ["Customer field is required"] });
                this.saving = false;
                return;
            }

            if (!products || !products.length) {
                this.$toaster.error('Добавьте хотя бы один товар');
                this.saving = false;
                return;
            }

            this.$parent.loading = true;

            axios.get("/api/admin/customer/" + this.sale.customer.customer_id, this.token).then((res) => {
                if (res.data.status != "Success") {
                    this.$toaster.error(res.data.message);
                    return;
                }

                // The offer this form already created, if it has, so saving
                // again changes that one.
                const editing = this.$route.params.id || this.offerId;

                var data = this.buildOrderData(res);
                data['type'] = 'offer';
                data['offers'] = products;

                return axios[editing ? 'put' : 'post'](
                    editing ? `/api/admin/offer/${editing}` : "/api/admin/offer",
                    data,
                    this.token
                )
                    .then((res) => {
                        if (res.data.status != "Success") {
                            this.$toaster.error(res.data.message);
                            return;
                        }

                        this.$toaster.success(res.data.message);

                        const id = editing || (res.data.data && res.data.data.order_id);

                        if (after === 'stay') {
                            // Held on to, so the next press updates this offer.
                            this.offerId = id || this.offerId;
                            return;
                        }

                        if (after === 'list' || !id) {
                            return this.$router.push("/admin/orders");
                        }

                        return this.$router.push(`/admin/order/${id}`);
                    })
                    .catch((error) => {
                        this.error_message = "";
                        this.errors = new ErrorHandling();

                        if (error.response && error.response.status == 422) {
                            if (error.response.data.status == "Error") {
                                this.$toaster.error(error.response.data.message);
                            } else {
                                this.errors.record(error.response.data.errors);
                            }
                        } else {
                            this.$toaster.error('Не удалось сохранить предложение');
                        }
                    });
            })
            .catch(() => this.$toaster.error('Не удалось сохранить предложение'))
            .finally(() => {
                this.$parent.loading = false;
                this.saving = false;
            });
        },
        saveTransaction(after = 'close') {
            this.errors = new ErrorHandling();
            let err = {};
            let isError = false;
            if (this.sale.warehouse_id == "") {
                err.warehouse_id = ["Warehouse field is required"];
                isError = true;
            }
            if (!this.sale.customer.customer_id) {
                err.customer = ["Customer field is required"];
                isError = true;
            }

            // if (Object.keys(this.selectedCustomerAddress).length === 0) {
            //     err.customer_address = ["Customer Address field is required"];
            //     isError = true;
            // }

            if (isError) {
                this.errors.record(err);
                this.saving = false;
            } else {
                this.sale.product_id.forEach((element, i) => {
                    if (this.sale.qty[i] != "" && this.sale.qty[i] != null
                        // && this.sale.product_discount_price_with_tax[i] != "" && this.sale.product_discount_price_with_tax[i] != null
                    ) {
                        var page_url = "/api/admin/cart";
                        this.$parent.loading = true;
                        axios.post(page_url,
                            {
                                product_id: element,
                                product_combination_id: this.sale.product_combination_id[i],
                                qty: this.sale.qty[i],
                                product_discount_price_with_tax: this.sale.discount_price_with_tax[i],
                                // The rate picked on the line, so the order and the
                                // invoice charge what the form showed.
                                tax_rate: this.selectedProducts[i] ? this.selectedProducts[i].tax_rate : null,
                                is_gift: this.isGiftLine(i) ? 1 : 0,
                                gift_promotion_id: this.isGiftLine(i) ? (this.selectedProducts[i].gift_promotion_id || null) : null,
                                customer_id: this.sale.customer.customer_id,
                                warehouse_id: this.sale.warehouse_id,
                            },
                            this.token
                        )
                            .then((res) => {
                                if (res.data.status == "Success") {
                                    document.getElementById('orderTable').rows.item(i + 1).style.color = "black";
                                    if (isError == false) {
                                        if (this.sale.product_id.length == i + 1) {
                                            var page_url =
                                                "/api/admin/customer/" + this.sale.customer.customer_id;
                                            axios.get(page_url, this.token).then((res) => {
                                                if (res.data.status == "Success") {
                                                    var page_url = "/api/admin/order";
                                                    var data = this.buildOrderData(res);
                                                    axios[this.$route.params.id ? 'put' : 'post'](this.$route.params.id ? `/api/admin/order/${this.$route.params.id}` : page_url, data, this.token)
                                                        .then((res) => {
                                                            if (res.data.status == "Success") {
                                                                this.$toaster.success(res.data.message);
                                                                this.saving = false;

                                                                const editing = this.$route.params.id;

                                                                // "Сохранить" оставляет менеджера в заказе. У нового
                                                                // заказа для этого есть только один адрес - его
                                                                // собственная карточка, иначе следующее сохранение
                                                                // создаст второй такой же заказ.
                                                                if (after === 'stay') {
                                                                    if (editing) {
                                                                        return;
                                                                    }

                                                                    const created = res.data.data && res.data.data.order_id;

                                                                    if (created) {
                                                                        return this.$router.push(`/admin/order/${created}/edit`);
                                                                    }
                                                                }

                                                                this.clearForm();

                                                                if (after === 'list' || !editing) {
                                                                    return this.$router.push("/admin/orders");
                                                                }

                                                                this.$router.push(`/admin/order/${editing}`);
                                                            } else {
                                                                this.$toaster.error(res.data.message);
                                                            }
                                                        })
                                                        .catch((error) => {
                                                            this.error_message = "";
                                                            this.errors = new ErrorHandling();
                                                            if (error.response.status == 422) {
                                                                if (error.response.data.status == "Error") {
                                                                    // this.error_message = error.response.data.message;
                                                                    this.$toaster.error(
                                                                        error.response.data.message
                                                                    );
                                                                } else {
                                                                    this.errors.record(error.response.data.errors);
                                                                }
                                                            }
                                                        })
                                                        .finally(() => (this.$parent.loading = false));
                                                } else {
                                                    this.$toaster.error(res.data.message);
                                                }
                                            });
                                        }
                                    }
                                } else {
                                    this.$toaster.error(res.data.message);
                                    this.loading = false;
                                    isError = true;
                                    //alert ("1");
                                    document.getElementById('orderTable').rows.item(i + 1).style.color = "red";
                                }
                            })
                            .catch((error) => {
                                this.error_message = "";
                                this.loading = false;
                                this.errors = new ErrorHandling();
                                if (error.response.status == 422) {
                                    if (error.response.data.status == "Error") {
                                        // this.error_message = error.response.data.message;
                                        this.$toaster.error(error.response.data.message);
                                        isError = true;
                                        document.getElementById('orderTable').rows.item(i + 1).style.color = "red";
                                    } else {
                                        this.errors.record(error.response.data.errors);
                                        isError = true;
                                        document.getElementById('orderTable').rows.item(i + 1).style.color = "red";
                                    }
                                }
                            })
                            .finally(() => (this.$parent.loading = false));
                    }
                });
            }
        },
        fetchCouponsByID(id) {
            this.$parent.loading = true;
            var token = localStorage.getItem("token");
            const config = {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            };

            axios.get("/api/admin/coupon_setting/" + id, config)
                .then((res) => {
                    if (res.data.status == "Success") {
                        this.selectedCoupon = res.data.data;
                    }
                })
                .finally(() => (this.$parent.loading = false));
        },
        fetchCoupons() {
            this.$parent.loading = true;
            var token = localStorage.getItem("token");
            const config = {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            };

            axios.get("/api/admin/coupon_setting", config)
                .then((res) => {
                    if (res.data.status == "Success") {
                        this.coupons = res.data.data;
                    }
                })
                .finally(() => (this.$parent.loading = false));
        },
        productTitle(product) {
            return product.product_title
                || (product.detail && product.detail[0] ? (this.localised(product.detail) || {}).title : "");
        },
        showSideBarProduct() {
            let data = this.products;
            this.category_products = [];
            for (let product of data) {
                if (product.product_type == "variable" && product.combination_detail) {
                    for (let combination_detail of product.combination_detail) {
                        // product.combination_detail[k].available_qty;
                        let product_name = this.productTitle(product) + " ";
                        for (let m = 0; m < combination_detail.combination.length; m++) {
                            if (combination_detail.combination.length - 1 == m) {
                                product_name += (this.localised(combination_detail.combination[m].variation.detail) || {}).name;
                            } else {
                                product_name += (this.localised(combination_detail.combination[m].variation.detail) || {}).name + "_";
                            }
                        }
                        var parms = {};
                        parms["product_name"] = product_name;
                        parms["product_id"] = product.product_id;
                        parms["product_type"] = product.product_type;
                        parms["product_combination_id"] =
                            combination_detail.product_combination_id;
                        parms["product_price"] = combination_detail.price;
                        this.category_products.push(parms);
                    }
                } else {
                    var parms = {};
                    parms["product_name"] = this.productTitle(product);
                    parms["product_id"] = product.product_id;
                    parms["product_combination_id"] = "";
                    parms["product_type"] = product.product_type;
                    parms["product_price"] = product.product_price;
                    parms["product_discount_price"] =
                        product.product_discount_price > 0
                            ? product.product_discount_price
                            : product.product_price;
                    this.category_products.push(parms);
                }
            }
        },
        async addProduct(selectedOption, id) {
            this.errors = new ErrorHandling();
            this.$parent.loading = true;

            // The chosen item goes into the table below; leaving it in the search
            // field only repeats what is already there.
            this.$nextTick(() => { this.productSearchSelection = null; });
            var token = localStorage.getItem("token");
            const config = {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            };
            var responseData = {};

            await axios
                .get("/api/admin/product/" + selectedOption.product_id + "?getDetailWithLanguage=1&getDetail=1", config)
                .then((res) => {
                    if (res.data.status == "Success") {
                        this.customIndex = 0;
                        var arr = {};
                        if (res.data.data.product_type == "simple") {
                            arr.product_id = res.data.data.product_id;
                            arr.product_type = res.data.data.product_type;
                            arr.title =
                                res.data.data.detail.length > 0
                                    ? (this.localised(res.data.data.detail) || {}).title
                                    : "";
                            arr.product_combination_id = null;
                            arr.qty = selectedOption.qty;
                            arr.stock_status = "";
                            arr.warehouse = "";
                            arr.available_qty = res.data.data.available_qty;
                            arr.product_sku = res.data.data.product_sku;
                            arr.product_price = res.data.data.product_price;
                            arr.product_price_with_vat = res.data.data.product_price_with_vat;
                            arr.product_discount_price_with_tax = res.data.data.product_result_price_with_vat;
                            arr.product_discount_price =
                                res.data.data.product_discount_price > 0
                                    ? res.data.data.product_discount_price
                                    : res.data.data.product_price_with_vat;
                            this.sale.qty.push(selectedOption.qty);
                            //arr.tax_rate = res.data.data.product_tax.tax_rate;
                            arr.tax_rate = Number(res.data.data.product_tax_rate);
                            this.selectedProducts.push(arr);
                        } else {
                            if (res.data.data.combination_detail.length > 0) {
                                for (let combination_detail of res.data.data.combination_detail) {
                                    arr.product_price = res.data.data.product_tax_rate > 0
                                            ? (combination_detail.price/parseFloat(res.data.data.product_tax_rate/100+1)).toFixed(3)
                                            : combination_detail.price
                                    arr.product_price_with_vat = combination_detail.price;
                                    arr.product_discount_price_with_tax = combination_detail.product_result_price_with_vat
                                    arr.product_discount_price = combination_detail.product_discount_price


                                    arr.product_combination_id = combination_detail.product_combination_id;
                                    arr.available_qty = combination_detail.available_qty;
                                    arr.product_sku = combination_detail.sku;

                                        var combination_name = "";
                                    if (combination_detail.combination.length > 0) {
                                        for (var j = 0; j < combination_detail.combination.length; j++) {
                                            if (j == 0) {
                                                combination_name = (this.localised(combination_detail.combination[j].variation.detail) || {}).name;
                                            } else {
                                                combination_name += "-" + (this.localised(combination_detail.combination[j].variation.detail) || {}).name;
                                            }
                                        }
                                    }
                                    arr.product_id = res.data.data.product_id;
                                    arr.product_type = res.data.data.product_type;
                                    arr.qty = selectedOption.qty;
                                    arr.stock_status = "";
                                    arr.warehouse = "";
                                    arr.ean = combination_detail.ean;
                                    arr.title =
                                        res.data.data.detail.length > 0
                                            ? (this.localised(res.data.data.detail) || {}).title + " (" + combination_name + ")"
                                            : "";
                                    //arr.tax_rate = res.data.data.product_tax.tax_rate;
                                    arr.tax_rate = Number(res.data.data.product_tax_rate);
                                    this.combination_products.push(arr);
                                    //alert ("i am here and working in some scenario");
                                    arr = {};
                                }

                            }
                        }
                        this.display_table = true;
                    }
                })
                .finally(() => (this.$parent.loading = false));
        },

        async addStartProduct(selectedOption, orderProduct) {
            this.customIndex = 0;
            let arr = {};
            if (orderProduct.product_type == "simple") {
                arr.product_id = orderProduct.product_id;
                arr.product_type = orderProduct.product_type;
                arr.title = orderProduct.product_title;
                arr.product_combination_id = null;
                arr.qty = selectedOption.qty;
                arr.stock_status = "";
                arr.warehouse = "";
                arr.available_qty = orderProduct.available_qty;
                arr.product_sku = orderProduct.product_sku;
                arr.product_price = orderProduct.product_price;
                arr.product_price_with_vat = orderProduct.product_price_with_vat;
                arr.product_discount_price_with_tax = orderProduct.product_result_price_with_vat;
                arr.product_discount_price =
                    orderProduct.product_discount_price > 0
                        ? orderProduct.product_discount_price
                        : orderProduct.product_price_with_vat;
                this.sale.qty.push(orderProduct.qty);
                arr.tax_rate = Number(orderProduct.product_tax_rate);
                this.selectedProducts.push(arr);
            } else {
                if (orderProduct.combination_detail.length > 0) {
                    for (let combination_detail of orderProduct.combination_detail) {
                        arr.product_price = orderProduct.product_tax_rate > 0
                            ? (combination_detail.price/parseFloat(orderProduct.product_tax_rate/100+1)).toFixed(3)
                            : combination_detail.price
                        arr.product_price_with_vat = combination_detail.price;
                        arr.product_discount_price_with_tax = combination_detail.product_result_price_with_vat
                        arr.product_discount_price = combination_detail.product_discount_price
                        arr.product_combination_id = combination_detail.product_combination_id;
                        arr.available_qty = combination_detail.available_qty;
                        arr.product_sku = combination_detail.sku;

                        var combination_name = "";
                        if (combination_detail.combination.length > 0) {
                            for (var j = 0; j < combination_detail.combination.length; j++) {
                                if (j == 0) {
                                    combination_name = (this.localised(combination_detail.combination[j].variation.detail) || {}).name;
                                } else {
                                    combination_name += "-" + (this.localised(combination_detail.combination[j].variation.detail) || {}).name;
                                }
                            }
                        }
                        arr.product_id = orderProduct.product_id;
                        arr.product_type = orderProduct.product_type;
                        arr.qty = selectedOption.qty;
                        arr.stock_status = "";
                        arr.warehouse = "";
                        arr.ean = combination_detail.ean;
                        arr.title =
                            orderProduct.product_title.length > 0
                                ? orderProduct.product_title + " (" + combination_name + ")"
                                : combination_name;
                        arr.tax_rate = Number(orderProduct.product_tax_rate);
                        this.combination_products.push(arr);
                        arr = {};
                    }
                }
            }
            this.display_table = true;
            this.$parent.loading = false
        },
        buildOrderData(customer = null){
            return {
                        code: this.sale.code,
                        is_add_sale: "1",
                        warehouse_id: this.sale.warehouse_id,
                        billing_first_name: customer?.data.data.customer_first_name,
                        billing_last_name: customer?.data.data.customer_last_name,
                        billing_street_address: this.sale.billing_street_address,
                        billing_country: this.sale.billing_country.country_id,
                        billing_state: this.warehouse_state_id,
                        billing_city: this.sale.billing_city,
                        billing_postcode: this.sale.billing_postcode,
                        billing_phone: this.sale.billing_phone
                            ? this.sale.billing_phone
                            : null,

                        delivery_first_name: customer?.data.data.customer_first_name,
                        delivery_last_name: customer?.data.data.customer_last_name,
                        delivery_street_address: this.sale.billing_street_address,
                        delivery_country: this.sale.billing_country.country_id,
                        delivery_state: this.warehouse_state_id,
                        delivery_city: this.sale.billing_city,
                        delivery_postcode: this.sale.billing_postcode,
                        delivery_phone: this.sale.billing_phone
                            ? this.sale.billing_phone
                            : null,
                        order_notes: this.sale.order_notes,
                        coupon_code: this.selectedCoupon
                            ? this.selectedCoupon.coupon_code
                            : "",
                        latlong: "12312312312",
                        currency_id: "1",
                        payment_method_id: this.sale.payment_method_id,
                        payment_method: this.payment_methods[this.sale.payment_method_id-1]?.payment_method_name,
                        shipping_method_id: this.sale.shipping_method_id,
                        shipping_option_id: this.sale.shipping_option_id,
                        shipping_cost: this.sale.shipping_cost,
                        customer_id: this.sale.customer?.customer_id,
                        order_status_id: this.sale.order_status_id ?? "1",
                        bill_note: this.sale.bill_note ?? "",
                        internal_note: this.sale.internal_note ?? "",
                        created_at: this.sale.sale_date ?? null,
                        billing_company_address: this.sale.billing_company_address,
                        company_id: this.sale.company_id,
                        company_bank_account_id: this.sale.company_bank_account_id || null,
                        exporter_id: this.sale.exporter_id,
                        // Left out when empty: an empty one would wipe the due
                        // date the order got when it was created.
                        payment_due_date: this.sale.payment_due_date || undefined,
                        invoice_description: this.sale.invoice_description || null,
                        invoice_sender: this.sale.invoice_sender || null,
                        invoice_sender_vat: this.sale.invoice_sender_vat || null,
                        invoice_transport: this.sale.invoice_transport || null,
                        invoice_trucker: this.sale.invoice_trucker || null,
                        invoice_delivery_date: this.sale.invoice_delivery_date || null,
                    };
        },
        addCombinationProduct(selectedOption, id) {
            this.selectedProducts.push(selectedOption);
            this.sale.qty.push(selectedOption.qty);
            setTimeout(() => {
                this.computeValues('addCombinationProduct');
            }, 300);
        },
        /**
         * Drop a line from the order.
         *
         * Removal used to be possible only by taking the tag out of the search
         * field, which meant the tags had to stay there - so the field grew with
         * every product added. The row owns its own remove button now.
         */
        removeSelectedProduct(index) {
            this.selectedProducts.splice(index, 1);
            this.sale.qty.splice(index, 1);
            this.sale.price.splice(index, 1);
            this.sale.product_combination_id.splice(index, 1);
            this.sale.product_id.splice(index, 1);
            this.sale.discount.splice(index, 1);
            this.sale.discount_price_with_tax.splice(index, 1);

            this.computeValues('removeProduct');
        },
        removeItem(removedOption, id) {
            //console.log(removedOption);
            // check if key exists
            const hasKey = "product_combination_id" in removedOption;
            if (hasKey) {
                if (
                    removedOption.product_combination_id != null &&
                    removedOption.product_combination_id != ""
                ) {
                    this.selectedProducts.forEach((el, index) => {
                        if (el.product_combination_id == removedOption.product_combination_id) {
                            this.selectedProducts.splice(index, 1);
                            this.sale.qty.splice(index, 1);
                            this.sale.price.splice(index, 1);
                            this.sale.product_combination_id.splice(index, 1);
                            this.sale.product_id.splice(index, 1);
                            this.sale.discount.splice(index, 1);
                            this.sale.discount_price_with_tax.splice(index, 1);
                        }
                    });

                    this.combination_product_id = this.combination_product_id.filter(
                        function (el) {
                            return (
                                el.product_id != removedOption.product_id &&
                                el.product_combination_id !=
                                removedOption.product_combination_id
                            );
                        }
                    );
                }
            } else {
                this.selectedProducts.forEach((el, index) => {
                    if (el.product_id == removedOption.product_id) {
                        this.selectedProducts.splice(index, 1);
                        this.sale.qty.splice(index, 1);
                        this.sale.price.splice(index, 1);
                        this.sale.product_combination_id.splice(index, 1);
                        this.sale.product_id.splice(index, 1);
                        this.sale.discount.splice(index, 1);
                        this.sale.discount_price_with_tax.splice(index, 1);
                    }
                });

                this.combination_product = this.combination_products.filter(function (el) {
                    //console.log(el);
                    return el.product_id != removedOption.product_id;
                });
                this.combination_products = this.combination_products.filter(item => item.product_id !== removedOption.product_id);

            }
            // this.selectedProducts.splice(index, 1);
            // this.stock.qty.splice(index, 1);
            setTimeout(() => {
                this.computeValues('removeProduct');
            }, 300);
        },
        nameWithLang(option) {
            // Search results carry a flat product_title, the order lines and
            // the older full-catalogue payload carry detail[0].title.
            let name = this.productTitle(option);

            if(option.product_ean) {
                name += " - "+option.product_ean;
            }

            if(option.product_sku) {
                name += " - "+option.product_sku;
            }

            if(option.product_barcodes) {
                name += " - "+option.product_barcodes;
            }
            if(option.product_barcode) {
                name += " - "+option.product_barcode;
            }

            if(option.stocks && option.stocks[0]) {
                name += " ("+option.stocks[0].remaining+")";
            } else if(option.available_qty !== undefined && option.available_qty !== null) {
                name += " ("+option.available_qty+")";
            }
            return name;
        },
        nameWithLangVariation(option) {
            let name = option.title;

            if(option.ean) {
                name += " - "+option.ean;
            }

            if(option.stocks && option.stocks[0]) {
                name += " ("+option.stocks[0].remaining+")";
            }
            return name;
        },
        customerNameSurname(option) {
            return (option.customer_first_name && option.customer_last_name) ? option.customer_first_name+" "+option.customer_last_name+" ("+option.customer_email+")" : option.customer_email;
        },
        countryName(option) {
            return (option.country_name ) ? option.country_name : "unknown";
        },
        companyName(option) {
            return (option.name ) ? option.name : "unknown";
        },
        getOrder(){
            this.errors = new ErrorHandling();
            this.$parent.loading = true;
            var token = localStorage.getItem("token");
            const config = {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            };
            var responseData = {};

            axios
                .get(`/api/admin/order/${this.$route.params.id}?orderDetail=1&productDetail=1&currency=1&billing_country=1&billing_state=1&delivery_country=1&delivery_state=1&customer=1`, config)
                .then(({data}) => {
                    data = data.data;
                    let date = data.order_date.split('/').reverse();
                    date[0] = `20${date[0]}`;
                    this.sale.code = data.code;
                    // The order carries the customer, so there is no need to
                    // hunt for it in a list of three thousand.
                    this.sale.customer = data.customer;
                    this.sale.billing_street_address = data.billing_street_address;
                    this.sale.billing_postcode = data.billing_postcode;
                    this.sale.billing_city = data.billing_city;
                    this.sale.billing_country = this.countries.find(item => item.country_id === data.billing_country);
                    this.sale.billing_email = data.customer.customer_email;
                    this.sale.billing_phone = data.billing_phone === 'no phone number' ? '' : data.billing_phone;
                    this.sale.billing_registration_number = data.customer.customer_registration_number;
                    this.sale.billing_tax_number = data.customer.customer_tax_number;
                    this.sale.billing_is_legal_person = this.sale.billing_registration_number && this.sale.billing_tax_number;
                    this.sale.billing_company_address = data.billing_company_address || data.customer.company_address;
                    this.sale.warehouse_id = data.warehouse_id;
                    this.sale.sale_date = date.join('-');
                    this.sale.payment_method_id = data.payment_method_detail.payment_method_id;
                    this.sale.payment_method = data.payment_method_detail.payment_method_name;
                    this.sale.shipping_method_id = data.shipping_method_detail?.shipping_method_id;
                    if(data.shipping_option_detail) {
                        this.sale.shipping_option_id = data.shipping_option_detail?.shipping_option_id;
                        this.fetchShippingOptions();
                    }
                    this.sale.shipping_cost= data.shipping_cost;
                    this.sale.order_id = data.order_id;
                    this.sale.order_status_id = data.order_status.id;
                    this.sale.internal_note = data.internal_note;
                    this.sale.bill_note = data.bill_note;
                    this.sale.company_id = data.company_id;
                    this.sale.company_bank_account_id = data.company_bank_account_id || '';
                    this.sale.exporter_id = data.exporter_id;
                    this.sale.payment_due_date = (data.payment_due_date || '').slice(0, 10);
                    this.sale.invoice_description = data.invoice_description || '';
                    this.sale.invoice_sender = data.invoice_sender || '';
                    this.sale.invoice_sender_vat = data.invoice_sender_vat || '';
                    this.sale.invoice_transport = data.invoice_transport || '';
                    this.sale.invoice_trucker = data.invoice_trucker || '';
                    this.sale.invoice_delivery_date = (data.invoice_delivery_date || '').slice(0, 10);
                    // The order already carries everything the lines need, so
                    // they are built from it directly. Looking them up in the
                    // product catalogue meant loading all of it first.
                    this.product_id = data.order_detail
                        .filter(order_product => order_product.product)
                        .map(order_product => order_product.product)
                        .filter((product, index, all) => {
                            return all.findIndex(other => other.product_id === product.product_id) === index
                        })

                    if(data.type == 'offer'){
                        this.type = 'offer';
                        this.$store.dispatch('offer/fetchProducts', data.order_id);
                        this.fetchOfferTotal();
                        /*this.offer_totals = {
                            'Итого' : this.total
                        };*/
                    }

                    this.product_id.forEach(item => {
                        let orderProduct = data.order_detail.find(order_product => {
                            return order_product.product.product_id === item.product_id
                        })
                        this.addStartProduct({ qty: orderProduct.product_qty }, orderProduct.product).then(() => {
                            //console.log(this.combination_products.length, 'length')
                            this.combination_product_id = this.combination_products.filter(item => {
                                //console.log(item, 'combination_products')
                                return data.order_detail.find(order_product => {
                                    //console.log(order_product, 'order_product')
                                    return order_product.product_combination ? order_product.product_combination.product_combination_id === item.product_combination_id : false
                                })
                            })

                            this.combination_product_id.forEach((item) => {
                                let alreadyIn = this.selectedProducts.filter(order_product => {
                                    return order_product.product_combination_id ? order_product.product_combination_id === item.product_combination_id : false
                                });
                                if(!alreadyIn.length) {
                                    this.addCombinationProduct(item)
                                }
                            })
                            this.selectedProducts.forEach((item, index) => {
                                if(item.product_combination_id !== null) {
                                    this.sale.qty[index] = Number(data.order_detail.find(order_product => {
                                        return order_product.product_combination ? order_product.product_combination.product_combination_id === item.product_combination_id : false
                                    }).product_qty);
                                    this.sale.discount_price_with_tax[index] = data.order_detail.find(order_product => {
                                        return order_product.product_combination ? order_product.product_combination.product_combination_id === item.product_combination_id : false
                                    }).product_discount_price_with_tax;
                                }
                                if(item.product_combination_id === null) {
                                    this.sale.qty[index] = Number(data.order_detail.find(order_product => {
                                        return order_product.product.product_id === item.product_id
                                    }).product_qty);
                                    this.sale.discount_price_with_tax[index] = data.order_detail.find(order_product => {
                                        return order_product.product.product_id === item.product_id
                                    }).product_discount_price_with_tax;
                                }
                            })

                            // The rate a line was saved with belongs to the line,
                            // not to the product. It was being read off the
                            // product, so a line moved to 0% came back at the
                            // product's 21% - and saving again wrote that back
                            // over the rate the order was placed at.
                            this.selectedProducts.forEach((item, index) => {
                                const line = data.order_detail.find(order_product => {
                                    if (item.product_combination_id) {
                                        return order_product.product_combination
                                            && order_product.product_combination.product_combination_id === item.product_combination_id;
                                    }

                                    return !order_product.product_combination
                                        && order_product.product.product_id === item.product_id;
                                });

                                if (line && line.product_tax_rate !== null && line.product_tax_rate !== undefined) {
                                    this.$set(item, 'tax_rate', Number(line.product_tax_rate));
                                }

                                if (line && line.is_gift) {
                                    this.$set(item, 'is_gift', true);
                                    this.$set(item, 'gift_promotion_id', line.gift_promotion_id || null);
                                    this.sale.discount_price_with_tax[index] = 0;
                                }
                            })

                            this.computeValues('addOrderProductInit');
                        });
                    });


                })
                .finally(() => (this.$parent.loading = false));
        },
        fetchOfferTotal(){
            var data = this.buildOrderData();
            data['type'] = 'offer';
            data['offers'] = this.$store.getters['offer/selectedProducts'];

            axios.post("/api/admin/offer-calculate", data, this.token)
                .then((res) => {
                    if (res.data.status == "Success") {
                        this.offer_totals = res.data.data;
                    }
                })
        }
    },
    mounted() {
        if(this.$route.meta.type){
            this.type = this.$route.meta.type;
        }
        var token = localStorage.getItem("token");
        this.token = {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };
        this.fetchProducts();
        this.fetchSaleQuotations();
        this.fetchCurrency();
        this.fetchWarehouses();
        
        this.fetchTaxes();
        this.fetchCoupons();
        this.fetchPaymentMethods();
        this.fetchShippingMethods();
        this.fetchCompanies();

        this.fetchCustomers();

        // Only the country list is still needed up front, and it is two
        // kilobytes. Everything else the order screen shows comes out of the
        // order itself.
        this.fetchCountries().then(() => {
            if (this.$route.params.id) {
                this.getOrder();
                this.fetchOrderStatuses();
                setTimeout(() => {
                    this.taxApply();
                }, 3000);
            }
        });
    },
    watch:{
        $route (to, from){
            location.reload();
        },

        // Changing the company invalidates the account picked from the previous
        // one, so fall back to that company's default.
        'sale.company_id' (to, from) {
            this.syncBankAccountChoice();
        },

        // Delivery is part of the total and carries VAT, so the summary has to
        // follow the field rather than wait for the page to be opened again.
        'sale.shipping_cost' (to, from){
            if (this.type == 'offer') {
                return this.fetchOfferTotal();
            }

            // The field is typed into, so wait for a pause rather than asking the
            // server about every keystroke of "12.50".
            clearTimeout(this.shippingTotalsTimer);
            this.shippingTotalsTimer = setTimeout(() => this.refreshTotals(), 300);
        },

        '$store.state.offer.selectedProducts': {
            handler(newSelectedProducts, oldSelectedProducts) {
                this.fetchOfferTotal();
            },
            deep: true,
        },

    },
    computed: {
        // The accounts of whichever company is selected. Shown only when there
        // is a choice to make.
        companyBankAccounts() {
            const company = this.companies.find(item => item.id === this.sale.company_id);

            return (company && company.bank_accounts) ? company.bank_accounts : [];
        },
        shippingPrice() {
            return Number(this.sale.shipping_cost.toString().replace(',','.'))
        },
        productsCount(){
            return this.sale.qty.reduce((sum, qty) => {
                if (qty) {
                    return sum + Number(qty);
                } else {
                    return sum;
                }
            }, 0);
        }
    }
};
</script>
